import { Component, signal } from '@angular/core';
import { Demographic } from './targets/demographic/demographic';
import { Detailed } from './targets/detailed/detailed';
import { Device } from './targets/device/device';

@Component({
  selector: 'cad-group-targeting',
  imports: [Demographic, Detailed, Device],
  templateUrl: './group-targeting.html',
  styleUrl: './group-targeting.css',
})
export class GroupTargeting {

  expanded = signal<boolean>(true);

}
